import apiUrl from '../../../constants'
import axios from 'axios'
export default new class {

	async getWarehouseList(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getClientList(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getDetailsForRTOGRC(token, input) {
		try {
			if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getDetailsForRTOGRCB2B',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async validateProuctGRCRTO(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateProuctGRCRTOB2B',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getImageEntry(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'addImageEntry',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async addImageEntry(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'addimage',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async qcRTO(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'saveReturnsRTOGRB2B',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async closeRTOGR(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'closeRTOGR',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getDetailsForSRGRC(token, input) {
		try {
			if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getDetailsForSRGRCb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async validateOrderIdForSRGRC(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateOrderIdForSRGRCb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async updateOrderIdRVPGRN(token, input) {
		try {
			const result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'updateOrderIdRVPGRNb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async updateOrderIdFlagSRReturn(token, input) {
		try {
			const result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'updateOrderIdFlagSRReturnb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async validateProductForSRGRC(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateProductForSRGRCb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async printLabelNOP(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.local_printer_api_url + 'printnopproduct',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async saveSRGRC(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'saveSRGRCb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async closeGRCSR(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'closeGRCSR',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async validateFRCAwb(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'addAwbForFRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async validateFRCOrder(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'addOrderToAWBFRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async validateProductFrcGrn(token, input){
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateProductFrcGrn',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async qcFRC(token, input){
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'saveGrnFRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
    async closeFrcSuborder(token, input){
         try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'closeSuborderIdFRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async closeFrcAWB(token, input){
         try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'closeAwbFRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
	async validateAWBForGRN(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateAWBForGRN',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async qcFRCGRN(token, input){
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'saveInitiatedGRNFRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
    async closeInitiatedFRC(token, input){
         try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'closeInitiatedFRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/rtogrnb2b/rtogrnb2b.js